import React from 'react';

const Constitution = () => {
  const laws = [
    'No citizen can alter any property that is not their own unless given verbal or written permission by the owner of the property.',
    'No citizen can fly an explosive broom within any built out area, and they need a Broom License and certification to fly a broom in general.',
    'No citizen can own the infinite ham item. To eat, food must be attained by citizens or bought from a business.',
    'No citizen can run a business without a Business License.',
    'No citizen can own TNT, except for mining and killing evil mobs.',
    'No citizen can plot to overthrow the government.',
    'No citizen can conspire with other citizens, non-citizens, or entities to enact violence at any level against any other citizen, non-citizen, or entity.',
    'No citizen can kill or hurt anyone else unless by self-defense.',
    'No citizen can take items or property (including animals and mobs) that isn’t their own unless given verbal or written permission.',
    'No citizen can extend a business beyond one market. Monopolies are punishable by death.',
    'No citizen can run a broom store. Only Clint Smith can do that.',
    'No citizen can run a business without some physical location.',
    'No citizen can commit stock or business fraud.',
  ];

  const rights = [
    'All citizens have the right to say whatever they want without punishment, unless it is a conspiracy.',
    'All citizens have the right to own and alter property that is their own.',
    'All citizens have the right to a fair public trial by the Establishment if they feel they were wrongly prosecuted.',
    'All citizens have the right to resist being searched by the government.',
    'All businesses have the right to refuse service to anyone they want.',
    'All citizens have the right to go onto any property, unless the property is labeled "Private".',
    'All citizens can enter any container / usable block (chest, furnace, etc.), unless it is labeled "Private" or is within a property labeled "Private".',
    'All citizens have the right to fair treatment under the law.',
  ];

  const policies = [
    'Money is generated by the Charlington National Bank. It is given to citizens on the basis of adding value to the country as determined by the Zard and the Establishment.',
    'Citizens can withdraw money from the Charlington National Bank in the form of designated items that cannot be forged. This money can be deposited back into the account.',
    'The majority shareholder in a company is not necessarily the main owner, though they could be. That aspect will be figured by the founder and other owner(s) for each business. Shareholders are entitled to somewhat regular dividends.',
  ];

  const civilResponsibilities = [
    'All citizens should kill any harmful mobs they see within the country.',
    'All citizens should fix any property damage caused by creepers/fire/TNT/brooms that they find to the best of their ability.',
    'All citizens should build a home.',
    'All citizens should start a business or work with an existing business.',
    'All citizens should buy from a business rather than harvesting or creating items themselves, if a business exists for that market.',
  ];

  var lawNumber = 0;
  var rightNumber = 0;
  var policyNumber = 0;
  var civilResponsibilityNumber = 0;
  var constitutionalAdditionsChangeNumber = 0;
  return (
    <div className='px-2 lg:px-16 py-8'>
      <p className='font-bold text-2xl text-center'>
        Constitution of Charlington
      </p>
      <p className='text-sm text-center font-semibold text-gray-400'>
        THE SUPREME LAW OF THE LAND
      </p>
      <p className='font-bold pt-5'>System of Government</p>
      <div>
        <p>
          Charlington's government has two parts, the Establishment and the
          Zard. The Establishment lays the groundwork for the functioning state
          of wizards, and the Zard leads the people. The Zard is chosen by the
          Establishment in an official election, with the only restriction being
          that the Zard cannot be the Establishment.
        </p>
      </div>
      <p className='font-bold pt-5'>Laws</p>
      <p className='pb-2'>The following laws must be followed.</p>
      {laws.map((law) => {
        lawNumber++;
        return (
          <div>
            <p>
              {lawNumber}. {law}
            </p>
          </div>
        );
      })}
      <p className='font-bold pt-5'>Rights</p>
      <p className='pb-2'>
        All citizens of Charlington have the following rights while in
        Charlington that cannot be infringed upon.
      </p>
      {rights.map((right) => {
        rightNumber++;
        return (
          <div>
            <p>
              {rightNumber}. {right}
            </p>
          </div>
        );
      })}
      <p className='font-bold pt-5'>Policies</p>
      <p className='pb-2'>
        The following policies describe necessary information for daily life.
      </p>
      {policies.map((policy) => {
        policyNumber++;
        return (
          <div>
            <p>
              {policyNumber}. {policy}
            </p>
          </div>
        );
      })}
      <p className='font-bold pt-5'>Civil Responsibilities</p>
      <p className='pb-2'>
        The following civil responsibilities are not required by law to perform,
        but they are preferred in order to maintain Charlington the best that is
        possible.
      </p>
      {civilResponsibilities.map((civilResponsibility) => {
        civilResponsibilityNumber++;
        return (
          <div>
            <p>
              {civilResponsibilityNumber}. {civilResponsibility}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default Constitution;
